import moment from "moment";
import { Input } from "reactstrap";
import React from "react";
import { Tooltip } from "@mui/material";

import CustomButton from "components/CustomButton";
import { ReactComponent as ActiveControl } from "assets/img/svg/ActiveControl.svg";
import { ReactComponent as InactiveControl } from "assets/img/svg/InactiveControl.svg";

import AChip from "../../common/chip/AChip";
import NoRowOverlay from "../holidayMaster/NoRowOverlay";
import ADataGrid from "../../common/data-grid/ADataGrid";
import { AGridColDef } from "../../common/data-grid/ADataGridColDef";
import CommonInput from "../../common/formFeilds/input/commonInput";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";
import { capitalize } from "../../common/utils/methods/commonMethods/utilityMethod";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";

import { editCellContainerStyle } from "../../edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import {
  gridStyles,
  gridComponents,
} from "../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant";
import {
  AAutoCompleteCustomStyles,
  getLabelById,
  getValueById,
  isObjEmpty,
} from "../pincode/constants";

const TableContent = ({
  rowData,
  rowForm,
  setRowForm,
  countryList,
  saveAll,
  userPermissions,
  deleteRow,
  loader,
  rowModesModel,
  startEditing,
  handleCancelClick,
}) => {
  const formattedDateTime = (timestamp) =>
    moment(timestamp).format("DD/MM/YYYY");

  const rowFormHandler = (value, key) => {
    setRowForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleEditClick = (params) => {
    if (!isObjEmpty(rowForm)) {
      failureToast("Please Delete or Save current changes");
    } else {
      startEditing(params?.id, params?.row);
    }
  };

  const columns = [
    new AGridColDef("countryId", "Country")
      .setMinWidth(100)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => getLabelById(countryList, params.value))
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <AAutoComplete
              placeholder="Select"
              items={countryList}
              currentValue={getValueById(countryList, rowForm?.countryId)}
              handleChange={(value) => {
                rowFormHandler(value?.value, "countryId");
              }}
              inputKey="country"
              {...AAutoCompleteCustomStyles}
            />
          </div>
        );
      }),

    new AGridColDef("stateKey", "State Key")
      .setMinWidth(80)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => params.value || "-")
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <CommonInput
            type="text"
            maxLength={"3"}
            forTable={true}
            restrictSpecialCharacter={true}
            defaultValue={rowForm?.stateKey}
            placeHolder={"Enter State Key"}
            className={"tdInput"}
            onChange={(value) => {
              rowFormHandler(value, "stateKey");
            }}
            height="31px"
          />
        </div>
      )),

    new AGridColDef("stateDesc", "Description")
      .setMinWidth(150)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <Input
              maxLength="50"
              defaultValue={rowForm?.stateDesc}
              onChange={(e) => {
                rowFormHandler(e.target.value, "stateDesc");
              }}
              placeholder="Description"
              className="tdInput"
            />
          </div>
        );
      }),

    new AGridColDef("stateDispValue", "Display Value")
      .setMinWidth(80)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      )
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <Input
            maxLength="50"
            defaultValue={rowForm?.stateDispValue}
            onChange={(e) => {
              rowFormHandler(e.target.value, "stateDispValue");
            }}
            placeholder="Display Value"
            className="tdInput"
          />
        </div>
      )),

    new AGridColDef("stateGstCode", "State GST Code")
      .setMinWidth(100)
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => params?.value || "-")
      .renderEditCellComponent((params) => (
        <div style={editCellContainerStyle}>
          <CommonInput
            type={"number"}
            maxLength={"2"}
            forTable={true}
            restrictSpecialCharacter={true}
            defaultValue={rowForm?.stateGstCode}
            placeHolder={"State GST Code"}
            className={"tdInput"}
            onChange={(value) => {
              rowFormHandler(value, "stateGstCode");
            }}
            height="31px"
          />
        </div>
      )),

    new AGridColDef("salesforceId", "Salesforce ID")
      .setMinWidth(180)
      .columnAlign("left")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("effectiveDate", "Effective Date")
      .setMinWidth(100)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={formattedDateTime(params?.value)}>
            <div className="ellipsis-text-container">
              {formattedDateTime(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("createdOn", "Created On")
      .setMinWidth(90)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={formattedDateTime(params?.value)}>
            <div className="ellipsis-text-container">
              {formattedDateTime(params?.value)}
            </div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("updatedBy", "Updated By")
      .setMinWidth(80)
      .columnAlign("left")
      .setFlex(0.5)
      .editable(false)
      .renderCellComponent((params) =>
        params?.value ? (
          <Tooltip title={params?.value}>
            <div className="ellipsis-text-container">{params?.value}</div>
          </Tooltip>
        ) : (
          <div className="m-auto">-</div>
        )
      ),

    new AGridColDef("status", "Status")
      .setMinWidth(120)
      .columnAlign("center")
      .setFlex(0.5)
      .editable(true)
      .renderCellComponent((params) => (
        <AChip
          label={capitalize(params?.value)}
          success={params.value === "ACTIVE"}
        />
      ))
      .renderEditCellComponent((params) => {
        return (
          <div style={editCellContainerStyle}>
            <span>
              {rowForm?.status === "ACTIVE" ? (
                <ActiveControl
                  onClick={() => rowFormHandler("INACTIVE", "status")}
                />
              ) : (
                <InactiveControl
                  onClick={() => rowFormHandler("ACTIVE", "status")}
                />
              )}
              <span className="ml-1">Active</span>
            </span>
          </div>
        );
      }),

    new AGridColDef("actions", "Action", false)
      .setMinWidth(140)
      .setFlex(0.5)
      .pinColumnLast(true)
      .renderCellComponent((params) =>
        params.api.getRowMode(params?.id) === "view" ? (
          <>
            <CustomButton
              content={""}
              permissionType={"U"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleEditClick(params);
              }}
              permissionSet={userPermissions}
            />

            <CustomButton
              content={""}
              permissionType={"D"}
              icon={true}
              forTable={true}
              onClick={() => {
                deleteRow(params.id);
              }}
              permissionSet={userPermissions} // for SuperAdmins only
            />
          </>
        ) : (
          <>
            <CustomButton
              content={"Save"}
              permissionType={"C,U"}
              icon={false}
              forTable={true}
              onClick={() => {
                // stopEditing(rowId);
                saveAll(params.row.id);
              }}
              permissionSet={userPermissions}
            />
            <CustomButton
              content={""}
              permissionType={"cancel"}
              icon={true}
              forTable={true}
              onClick={() => {
                handleCancelClick(params);
              }}
              permissionSet={userPermissions}
            />
          </>
        )
      ),
  ];

  return (
    <div className="mt-3 ml-3" style={{ height: "100%" }}>
      <ADataGrid
        removeWrapperContainer
        rowModesModel={rowModesModel}
        rows={rowData || []}
        columns={columns}
        rowId={(row) => row.id}
        rowHeight={50}
        loading={false}
        rowCount={rowData?.length}
        components={{
          ...gridComponents,
          NoRowsOverlay: () => (
            <NoRowOverlay message={loader ? "Loading..." : null} />
          ),
        }}
        sx={gridStyles}
        pinLastColumn
      />
    </div>
  );
};

export default TableContent;
